import { EmailTypes } from "../../types/EmailTypes";
import { RequestDemoForm } from "../../classes/RequestDemoForm";
import { GACategoryTypes } from "../../types/GACategoryTypes";
import { GAEventTypes } from "../../types/GAEventTypes";

export class GetDemoVersionModalComponent {

  selectedProducts = [];
  formSent = false;

  _demoVersionModalEl;
  _nextButtonsElements;
  _stepsViewsElements;
  _demoVersionModalContentEl;
  _isFirstLoad = true;
  _emailInputEl;
  _sendButtonEl;
  _emailEl;
  _isInit = false;

  constructor() {
  }

  init() {
    this._demoVersionModalEl = document.querySelector('#get-demo-version-modal');
    this._demoVersionModalContentEl = this._demoVersionModalEl.querySelector('.get-demo-version-modal-content-wrapper');
    this._emailEl = this._demoVersionModalEl.querySelector('.additional-text .email');
    this._emailInputEl = this._demoVersionModalEl.querySelector('input[id="senderEmail"]');
    this._sendButtonEl = this._demoVersionModalEl.querySelector('button[type="submit"]');

    if (this._demoVersionModalEl) {
      this.modalActions();
    }
  }

  modalActions() {
    this._nextButtonsElements = this._demoVersionModalEl.querySelectorAll('.next-button');
    this._stepsViewsElements = this._demoVersionModalEl.querySelectorAll('.step');
    this._stepsViewsElements.forEach(x => {
      if (!x.classList.contains('d-none')) {
        x.classList.add('d-none');
      }
    });
    this._stepsViewsElements[0].classList.remove('d-none');
    this.selectedProducts = [];
    this._emailInputEl.addEventListener('blur', this.validEmail.bind(this))

    this.stepFirstActions();
  }

  stepFirstActions() {
    if (
      typeof ga === 'function' &&
      window['areCookiesPreferencesSet'] &&
      window['cookiesPreferences'].analyticsCookie
    ) {
      ga('send', 'event', GACategoryTypes.TrackingContactUs, GAEventTypes.DemoStart);
      dataLayer.push({ 'event': `cc_${ GACategoryTypes.TrackingContactUs }_${ GAEventTypes.DemoStart }` });
    }

    const selectedAppId = this._demoVersionModalContentEl.getAttribute('data-selected-app-id');
    const checkboxes = Array.from(this._stepsViewsElements[0].querySelectorAll(
      '.get-demo-version-modal-content-wrapper__step-1__apps__app input[type="checkbox"]')
    );
    const selectAllCheckbox = this._stepsViewsElements[0].querySelector('.select-all-row input[type="checkbox"]');
    const appsToRemove = this._stepsViewsElements[0].querySelectorAll('.get-demo-version-modal-content-wrapper__step-1__apps__app[data-app-id=""]');

    appsToRemove.forEach(a => a.remove());
    // checkboxes.forEach(this.markAppAsUnSelected);
    // selectAllCheckbox.checked = false;

    if (selectedAppId) {
      this.markAppAsSelected(checkboxes.find(x => x.value === selectedAppId));
      this.selectedProducts[0] = selectedAppId;
    } else {
      this._nextButtonsElements[0].classList.add('pointer-events-none');
      this._nextButtonsElements[0].disabled = true;
    }

    if (this._isFirstLoad) {
      checkboxes.forEach(x => {
        x.addEventListener('change', (e) => {
          const { value } = x;

          if (x.checked && !this.selectedProducts.includes(value)) {
            this.selectedProducts.push(value);
            this.markAppAsSelected(x);

          } else {
            this.markAppAsUnSelected(x);
            if (this.selectedProducts.includes(value)) {
              this.selectedProducts = this.selectedProducts.filter(product => product !== value);
            }
          }

          if (this.selectedProducts.length) {
            this._nextButtonsElements[0].classList.remove('pointer-events-none');
            this._nextButtonsElements[0].disabled = false;
          } else {
            this._nextButtonsElements[0].classList.add('pointer-events-none');
            this._nextButtonsElements[0].disabled = true;
          }

          if (e.isTrusted) {
            selectAllCheckbox.checked = this.selectedProducts.length === checkboxes.length;
          }
        });
      });
      checkboxes.forEach(x => {
        if (x.checked) {
          this.selectedProducts.push(x.value)
        }
      })

      selectAllCheckbox.addEventListener('change', () => {
        checkboxes.filter(x => x.checked !== selectAllCheckbox.checked).forEach(x => {
          x.checked = selectAllCheckbox.checked;
          x.dispatchEvent(new Event('change'));
        });
      });

      // this._nextButtonsElements[0].addEventListener('click', this.changeStep.bind(this, 0, 1, this.stepSecondActions));
    }

    this._isFirstLoad = false;
    this.changeStep(0, 1, this.stepSecondActions)
  };

  stepSecondActions() {
    const form = this._stepsViewsElements[1].querySelector('#demo-version-form');
    // const backButton = this._stepsViewsElements[1].querySelector('.back-button');

    // backButton.addEventListener('click', this.changeStep.bind(this, 1, 0));

    const requestDemoForm = new RequestDemoForm(
      form,
      EmailTypes.RequestDemo,
      this.selectedProducts,
      GACategoryTypes.TrackingContactUs,
      GAEventTypes.DemoSent,
      this.showConfirmationEl.bind(this),
    );

    if(!this._isInit) {
      requestDemoForm.init();
    }
    this._isInit = true;
  }

  markAppAsSelected(appEl) {
    appEl.checked = true;
    appEl.parentElement.parentElement.classList.add(
      'get-demo-version-modal-content-wrapper__step-1__apps__app--selected'
    );
  }

  markAppAsUnSelected(appEl) {
    appEl.checked = false;
    appEl.parentElement.parentElement.classList.remove(
      'get-demo-version-modal-content-wrapper__step-1__apps__app--selected'
    );
  }

  changeStep(currenViewIndex, nextViewIndex, afterViewChangedCb) {
    this._stepsViewsElements[currenViewIndex].classList.add('d-none');
    this._stepsViewsElements[nextViewIndex].classList.remove('d-none');

    if (afterViewChangedCb) {
      afterViewChangedCb.call(this);
    }
  }

  validEmail(evt) {
    const value = evt.target.value;
    const notAllowedEmail = ['@hotmail.', '@live', '@msn.', '@windowslive.', '@gmail.'];
    const invalidEmailText = this._demoVersionModalEl.querySelector('.contact-form__invalid-email');
    if(notAllowedEmail.some((item) => value.includes(item))) {
      invalidEmailText.classList.remove('d-none');
      this._sendButtonEl.disabled = true;
    } else {
      invalidEmailText.classList.add('d-none');
      this._sendButtonEl.disabled = false;
    }
  }

  showConfirmationEl(email, emailIsUsed = false) {
    if (emailIsUsed) {
      this.formSent = false;
      const emailInUseEl = document.querySelector('.contact-form__email-in-use');
      emailInUseEl.classList.remove('d-none')
    } else {
      this.changeStep(1, 2);
      this.selectedProducts = [];
      this.formSent = true;

      if (email !== '') {
        this._emailEl.textContent = email;
      }
    }
  }

  reload() {
    this.formSent = false;
    this._emailEl.textContent = '';
    this.modalActions();
  }
}
